// Free tools published in each light language (D-231). The tool pages are the only public pages of a light language;
// src/marketing-pages.<locale>.json lists exactly these slugs (a test keeps them equal). Tools that need
// language-specific teaching content (report-card comments, charades, certificates, phonics…) wait for a full language.
import type { LightLocale } from "./i18n/locales";

/** The 25 tools that need no language-specific teaching content: the first light-language batch (Italian, Thai, Ukrainian, Dutch). */
const SHARED_LIGHT_TOOLS = [
    "random-picker", "timer", "scoreboard", "random-groups", "noise-meter", "seating-chart", "times-tables", "dice-coin", "poll",
    "stopwatch", "random-number", "1a2b", "mental-math", "online-clock", "school-bell", "random-order", "hundreds-chart",
    "tic-tac-toe", "schulte-table", "tower-of-hanoi", "24-game", "bingo-cards", "guess-number", "protractor", "metronome",
];

export const LIGHT_TOOL_SLUGS: Record<LightLocale, ReadonlySet<string>> = {
  th: new Set(SHARED_LIGHT_TOOLS),
  // Ukrainian also has the student comment generator (D-236): its comment bank is the one thing Ukrainian teachers search for most.
  uk: new Set([...SHARED_LIGHT_TOOLS, "report-comments"]),
  nl: new Set(SHARED_LIGHT_TOOLS),
  it: new Set(SHARED_LIGHT_TOOLS),
};
